var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.094,
    height: 28.093,
    viewBox: "0 0 28.094 28.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761",
    transform: "translate(-7.81 -7.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32494",
    "data-name": "Path 32494",
    d: "M32.783,47.371V27.082a.52.52,0,0,1,.52-.52h2.081a.52.52,0,0,1,.52.52v20.81a.52.52,0,0,1-.52.52H8.332a.52.52,0,0,1-.52-.52V43.729a.52.52,0,0,1,.52-.52h2.081a.52.52,0,0,1,.52.52v3.642h3.121v-7.8a.52.52,0,0,1,.52-.52h2.081a.52.52,0,0,1,.52.52v7.8H20.3V35.406a.52.52,0,0,1,.52-.52H22.9a.52.52,0,0,1,.52.52V47.371h3.121V31.244a.52.52,0,0,1,.52-.52h2.081a.52.52,0,0,1,.52.52V47.371Z",
    transform: "translate(-0.001 -12.507)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32495",
    "data-name": "Path 32495",
    d: "M32.829,9.757a1.623,1.623,0,0,1-.047-.384,1.561,1.561,0,1,1,1.561,1.561,1.546,1.546,0,0,1-.935-.312l-3.794,2.53a1.623,1.623,0,0,1,.047.384A1.562,1.562,0,0,1,28.1,15.1a1.546,1.546,0,0,1-.935-.312l-3.794,2.53a1.623,1.623,0,0,1,.047.384,1.562,1.562,0,0,1-1.561,1.561,1.546,1.546,0,0,1-.935-.312l-3.794,2.53a1.623,1.623,0,0,1,.047.384,1.562,1.562,0,0,1-1.561,1.561,1.546,1.546,0,0,1-.935-.312l-3.794,2.53a1.623,1.623,0,0,1,.047.384A1.561,1.561,0,1,1,9.371,24.46a1.546,1.546,0,0,1,.935.312l3.794-2.53a1.623,1.623,0,0,1-.047-.384A1.562,1.562,0,0,1,15.614,20.3a1.546,1.546,0,0,1,.935.312l3.794-2.53A1.623,1.623,0,0,1,20.3,17.7a1.562,1.562,0,0,1,1.561-1.561,1.546,1.546,0,0,1,.935.312l3.794-2.53a1.623,1.623,0,0,1-.047-.384A1.562,1.562,0,0,1,28.1,11.974a1.546,1.546,0,0,1,.935.312Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.61e3e60c9000aa14a74184b532f56031.svg";
export { ForwardRef as ReactComponent };